import { t, useI18n } from "@bookingcom/lingojs-react";
import { ErrorPage } from "../components/ErrorPage";

export const ErrorComponent = () => {
  const i18n = useI18n();

  return (
    <ErrorPage
      title={i18n.trans(t("flights_airline_portal_airline_view_realtime_error_api_all_header"))}
      description={i18n.trans(t("flights_airline_portal_airline_view_realtime_error_api_all_body"))}
    />
  );
};
